import { HttpClient } from '@angular/common/http';

import { Injectable } from "@angular/core";
import { Observable } from 'rxjs';
import { CompanyInfo } from './company-info';

@Injectable()
export class CompanyInfoService {
  constructor(private httpClient: HttpClient) {

  }

  public getCompanyInfo(): Observable<CompanyInfo> {
    return this.httpClient.get<CompanyInfo>("/api/info/company");
  }
}